import capitalize from 'just-capitalize'
import { ICustomerAccount } from '../interfaces'

export function formatBranchName(account: ICustomerAccount) {
  if (!account) return ''
  return `${capitalize(account?.customerName ?? '')} - ${capitalize(account?.primaryCity ?? '')}${
    account?.primaryState !== 'Not Available' ? ', ' + account?.primaryState?.toUpperCase() : ''
  }`.replace(/llc(\w)?/, (...args) => 'LLC' + (args.at(1) ? args.at(1).toUpperCase() : ''))
}
